import { gql } from 'graphql-request'

export const SETORES_QUERY = gql`
  query Setores {
    setores {
      id
      nome
      divisao {
        id
        nome
      }
    }
  }
`
